import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "../layout/Layout";


import Home from "../../pages/Homepage/Home";
import Service from "../../pages/service/Service";
import About from "../../pages/aboutus/About";
import Product from "../../pages/productpage/Product";
import Contact from "../../pages/contactpage/Contact";
import ScrollToTop from "../scrolltotop/ScrollToTop";

const Navigation = () => {
  return (
    <BrowserRouter>
      <ScrollToTop /> {/* 👈 important */}
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="products" element={<Product />} />
          <Route path="services" element={<Service />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Navigation;